import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const LiveScience: Site = {
  id: 'livescience',
  logo: 'svg/livescience.svg',
  label: 'Live Science',
  analyticsName: 'livescience',
  hostname: 'livescience.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
